"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./style.scss");
const IMAGES_PATH = "./images/";
const SOUNDS_PATH = "./sounds/";
const audio = new Audio();
audio.loop = true;
let currentSound = null;
const buttons = document.querySelectorAll(".buttons button");
const volumeControl = document.querySelector("#volume");
document.body.style.backgroundImage = `url('${IMAGES_PATH}summer-bg.jpg')`;
buttons.forEach((button) => {
    const images = button.getAttribute("data-image");
    images && (button.style.backgroundImage = `url('${IMAGES_PATH}${images}')`);
    button.addEventListener("click", () => handleButtonClick(button));
});
volumeControl === null || volumeControl === void 0 ? void 0 : volumeControl.addEventListener("input", () => handleVolumeChange(volumeControl));
const handleButtonClick = (button) => {
    const sound = button.getAttribute("data-sound");
    const image = button.getAttribute("data-image");
    if (currentSound === sound) {
        (audio === null || audio === void 0 ? void 0 : audio.paused) ? audio === null || audio === void 0 ? void 0 : audio.play() : audio === null || audio === void 0 ? void 0 : audio.pause();
    }
    else {
        playNewAudio(sound, image);
    }
};
const handleVolumeChange = (volumeControl) => {
    audio && (audio.volume = +volumeControl.value);
};
const playNewAudio = (sound, image) => {
    if (!sound)
        return;
    audio === null || audio === void 0 ? void 0 : audio.pause();
    audio.src = `${SOUNDS_PATH}${sound}.mp3`;
    volumeControl && (audio.volume = +volumeControl.value);
    audio.play();
    currentSound = sound;
    image &&
        (document.body.style.backgroundImage = `url('${IMAGES_PATH}${image}')`);
};
